<template>
  <div>
    <!-- PC -->
    <div class="banner">
      <div class="con">
        <div class="text">
          <h1 class="title">混合云</h1>
          <h6 class="des">
            核心资源不出本地，为中大型企业打造专属定制系统，提供多应用场景下合同管理、电子签章、实体印章、用印管理的一体化解决方案。
          </h6>

          <div class="btn" @click="showDialog">了解更多</div>
        </div>
        <div class="bg"><img src="../../../../assets/images/mixOsBanner-small.png" /></div>
      </div>
    </div>
    <!-- h5 -->
    <div class="banner-mobile">
      <img class="img" src="../../../../assets/images/mixOsBannerMobile.png" />
      <div class="con">
        <div class="title">混合云</div>
        <div class="des">
          核心资源不出本地，为中大型企业打造专属定制系统，提供多应用场景下合同管理、电子签章、用印管理的一体化解决方案。
        </div>
        <div class="btn" @click="showDialog">了解更多</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showForm: Boolean,
    list: Array,
    video: String,
    landingPageName: {
      type: String,
      default: '',
    },
  },
  components: {},
  methods: {
    closeform(e) {
      console.log(e)
    },
    showDialog() {
      this.$emit('showDialog')
    },
    setShowSuccessDialog(v) {
      this.$emit('setShowSuccessDialog', v)
    },
  },
}
</script>

<style lang="less" scoped>
@media screen and (min-width: 768px) {
  .banner-mobile {
    display: none;
  }
  .banner {
    width: 100%;
    height: 560px;
    padding: 0 5%;
    background-color: #edeef3;
    .con {
      position: relative;
      max-width: 1320px;
      height: 560px;
      margin: 0 auto;

      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
    .bg {
      width: 50%;
    }
    .text {
      position: absolute;
      top: 171px;
      left: 0px;
      .title {
        font-size: 40px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: #000000;
        line-height: 56px;
        margin-bottom: 20px;
      }
      .des {
        width: 52%;
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: normal;
        color: #202640;
        line-height: 30px;
      }
      .btn {
        margin-top: 30px;
        display: flex;
        align-items: center;
        flex-direction: column;
        width: 120px;
        height: 40px;
        background-color: #e61717;
        color: #fff;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .banner {
    display: none;
  }
  .banner-mobile {
    width: 100%;
    height: 9.6rem;
    // background: url('../../../../assets/images/mixOsBannerMobile.png') no-repeat;
    // background-size: contain;
    // padding: 98px 28px 80px;
    position: relative;
    .img {
      width: 100%;
      height: 9.6rem;
    }
    .con {
      position: absolute;
      top: 2.1333rem;
      padding: 0 0.7467rem;
      min-width: auto;
      .title {
        font-size: 0.7467rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 1.0667rem;
        letter-spacing: 0.0533rem;
        text-align: center;
        margin-bottom: 0.2667rem;
      }
      .des {
        font-size: 0.3733rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 0.5333rem;
        letter-spacing: 1px;
        text-align: center;
        margin-bottom: 1.0667rem;
      }
      .btn {
        display: block;
        width: 2.6667rem;
        height: 0.8rem;
        background: #e61717;
        text-align: center;
        font-size: 0.32rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 0.4533rem;
        margin: 0 auto;
      }
    }
  }
  .fadeInUp {
    visibility: visible;
    animation-delay: 150ms;
    animation-name: fadeInUp;
  }

  @-webkit-keyframes fadeInUp {
    0% {
      opacity: 0;
      transform: translateY(20px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes fadeInUp {
    0% {
      opacity: 0;
      transform: translateY(20px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
}
</style>
